__turbopack_context__.v({
  "disabled": "_2bnbLa_disabled",
  "toggleBlock": "_2bnbLa_toggleBlock",
  "toggleChip": "_2bnbLa_toggleChip",
  "toggleContainer": "_2bnbLa_toggleContainer",
  "toggleInput": "_2bnbLa_toggleInput",
});
